import { useEffect, useState } from 'react';
import { Weglot } from '../types/weglot/weglot.types';

type UseWeglotPayload = {
  weglot: Weglot | undefined;
};

export const useWeglot = (): UseWeglotPayload => {
  const [weglot, setWeglot] = useState<undefined | Weglot>();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.Weglot) {
      setWeglot(window.Weglot);
    }
  }, []);

  return {
    weglot,
  };
};
